import { Box, Grid, LinearProgress, Stack, Typography } from "@mui/material";

import { InsightsCardSkeleton } from "../../components/Insights/InsightsAsyncState";
import KeyValueCard from "../pricing-reports/design/KeyValueCard";
import { completionPercent } from "./verifyPriceUtils";

export default function VerifyPriceSummaryCards({ counts, isLoading }) {
  const verifiedCount = counts?.verifiedCount || 0;
  const unverifiedCount = counts?.unverifiedCount || 0;
  const totalCount = counts?.totalCount || 0;
  const percent = completionPercent(verifiedCount, totalCount);
  const formatCount = (value) => (isLoading ? "—" : value.toLocaleString());

  return (
    <Stack spacing={1.5}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4} sx={{ display: "flex" }}>
          {isLoading ? (
            <InsightsCardSkeleton sx={{ flex: 1 }} />
          ) : (
            <KeyValueCard label="Unverified" value={formatCount(unverifiedCount)} sx={{ width: "100%", flex: 1 }} />
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={4} sx={{ display: "flex" }}>
          {isLoading ? (
            <InsightsCardSkeleton sx={{ flex: 1 }} />
          ) : (
            <KeyValueCard label="Verified" value={formatCount(verifiedCount)} sx={{ width: "100%", flex: 1 }} />
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={4} sx={{ display: "flex" }}>
          {isLoading ? (
            <InsightsCardSkeleton sx={{ flex: 1 }} />
          ) : (
            <KeyValueCard
              label="Total data points"
              value={formatCount(totalCount)}
              sx={{ width: "100%", flex: 1 }}
            />
          )}
        </Grid>
      </Grid>
      <Box>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.75 }}>
          {isLoading ? "Completion" : `${percent}% complete`}
        </Typography>
        <LinearProgress
          variant="determinate"
          value={isLoading ? 0 : percent}
          aria-label="Verification completion"
          sx={{ height: 8, borderRadius: "999px" }}
        />
      </Box>
    </Stack>
  );
}
